export enum AchRefundApiRoutes {
  Transactions = '/carts/:id/refundable-transactions',
  Process = '/carts/:id/manual-refund',
}
